import { FOR_INVESTORS_SECTIONS, IForInvestorsSections } from 'constants/businessToolSections/forInvestors';

export const isForInvestorsSection = (section: any): section is IForInvestorsSections =>
  Object.values(FOR_INVESTORS_SECTIONS).includes(section);
